export default __webpack_public_path__ + "static/media/AddNewPatient.1ecea4cc.svg";